module.exports = __webpack_public_path__ + "static/media/Feedback-icon.1490f1a9.svg";